import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { SLA_GROUPS_ACTION_TYPE } from '../actions';

const initialState = {};

const slaGroupsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SLA_GROUPS_ACTION_TYPE.GET_SLA_GROUPS:
        return payload || state;

      case SLA_GROUPS_ACTION_TYPE.ADD_SLA_GROUP:
      case SLA_GROUPS_ACTION_TYPE.EDIT_SLA_GROUP:
        draft[payload.id] = { ...state[payload.id], ...payload };
        break;

      case SLA_GROUPS_ACTION_TYPE.DELETE_SLA_GROUP:
        delete draft[payload];
        break;

      case SLA_GROUPS_ACTION_TYPE.ADD_SLA_LEVEL:
        draft[payload.slaGroupId].levels.push(payload);
        break;

      case SLA_GROUPS_ACTION_TYPE.EDIT_SLA_LEVEL:
        {
          const levelIndex = state[payload.slaGroupId].levels.findIndex(
            ({ id }) => id === payload.id,
          );
          draft[payload.slaGroupId].levels[levelIndex] = payload;
        }

        break;

      case SLA_GROUPS_ACTION_TYPE.DELETE_SLA_LEVEL:
        draft[payload.slaGroupId].levels = state[payload.slaGroupId].levels.filter(
          ({ id }) => id !== payload.slaLevelId,
        );
        break;

      case SLA_GROUPS_ACTION_TYPE.REORDER_SLA_GROUP:
        draft[payload.slaGroupId].levels = _.sortBy(draft[payload.slaGroupId].levels, ({ id }) =>
          payload.list.indexOf(id),
        );
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default slaGroupsReducer;
